import { ApiSuccess } from "@/interfaces/common/Success";
import { Client, ClientNotification } from "@/interfaces/domain/Client";
import { Product } from "@/interfaces/domain/Product";
import { api } from "@/services/api";

export type UpdateClientParams = {
  metodo_pagamento: string;
  enderecos: string[];
  favoritos: any[];
  nome: string;
  razao_social: string;
  media_faturamento: number;
  telefone: string;
  notificacoes: any[];
  endereco_principal: string;
  data_nascimento: string;
};

export async function updateClientRequest(
  id: string,
  params: Partial<UpdateClientParams>
): Promise<Client> {
  const { data } = await api.put<Client>(`/clientes/${id}`, params);
  return data;
}

export async function getClientFavoriteProductListRequest(id: string) {
  const { data } = await api.get<Product[]>(`/clientes/${id}/favoritos`);
  return data;
}

export async function addClientFavoriteProductRequest(clientId: string, productId: string) {
  const { data } = await api.post<Client>(`/clientes/${clientId}/favoritos`, {
    id_produto: productId,
  });
  return data;
}

export async function removeClientFavoriteProductRequest(clientId: string, productId: string) {
  const { data } = await api.delete<Client>(`/clientes/${clientId}/favoritos/${productId}`);
  return data;
}

export async function getClientNotificationListRequest(id: string) {
  const { data } = await api.get<ClientNotification[]>(`/clientes/${id}/notificacoes`);
  return data;
}

export async function removeClientNotificationRequest(clientId: string, notificationId: string) {
  const { data } = await api.delete<ApiSuccess>(
    `/clientes/${clientId}/notificacoes/${notificationId}`
  );
  return data;
}

export async function deactivateClientRequest(clientId: string) {
  await api.delete<void>(`/clientes/${clientId}`);
}
